import React, { useState, useEffect } from 'react';
import { getSignedVideoUrl } from '../api/videoLessonApi';

const SignedVideoPlayer = ({ videoUrl, className, controls = true, autoPlay = false, ...props }) => {
  const [signedUrl, setSignedUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSignedUrl = async () => {
      if (!videoUrl) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        const response = await getSignedVideoUrl(videoUrl);
        setSignedUrl(response.data.signedUrl);
      } catch (err) {
        console.error('Error fetching signed URL:', err);
        setError('Failed to load video');
      } finally {
        setLoading(false);
      }
    };

    fetchSignedUrl();
  }, [videoUrl]);

  if (loading) {
    return (
      <div className={`video-loading ${className || ''}`} style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#000',
        color: '#fff',
        minHeight: '200px'
      }}>
        Loading video...
      </div>
    );
  }

  if (error) {
    return (
      <div className={`video-error ${className || ''}`} style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#000',
        color: '#ff4757',
        minHeight: '200px',
        padding: '20px',
        textAlign: 'center'
      }}>
        {error}
      </div>
    );
  }

  if (!signedUrl) {
    return null;
  }

  return (
    <video
      className={className}
      controls={controls}
      autoPlay={autoPlay}
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        background: '#000'
      }}
      {...props}
    >
      <source src={signedUrl} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
};

export default SignedVideoPlayer;

